import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { Grid } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import BreadCrumb from '../../../../components/breadcrumb/BreadCrumb';
import AvailabilityInfoBox from '../../components/AvailabilityInfoBox';
import EventImage from '../../components/EventImage';

export const StyledGrid = styled(Grid)`
  row-gap: ${spacing.space48};
`;

export const Content = styled.div`
  grid-column: 4/10;

  @media (max-width: ${breakpoints.l}) {
    grid-column: 1 / 13;
  }
`;

export const StyledBreadCrumb = styled(BreadCrumb)`
  margin-bottom: ${spacing.space32};

  @media (min-width: ${breakpoints.xl}) {
    margin-bottom: ${spacing.space48};
  }
`;

export const StyledAvailabilityInfoBox = styled(AvailabilityInfoBox)`
  margin-top: ${spacing.space40};
`;

export const StyledTitle = styled(Text)`
  margin: ${spacing.space16} 0;
`;

export const Ingress = styled(Text)`
  margin: 0;
`;

export const StyledImage = styled(EventImage)`
  width: 100%;
  height: auto;
  grid-column: 3/11;

  @media (max-width: ${breakpoints.l}) {
    grid-column: 1 / 13;
  }
`;

export const TextNoMargin = styled(Text)`
  margin-bottom: 0;
`;
